import { deleteBasketItem } from 'api/v2/expenses/basket';
import useMutation from 'hooks/react-query/useMutation';

import useGetBasket from './useGetBasket';

const useDeleteBasketItem = (onSuccess?: () => void) => {
  const basketQuery = useGetBasket();

  return useMutation((id: string) => deleteBasketItem(id), {
    onSuccess: () => {
      basketQuery.refetch();
      onSuccess?.();
    },
  });
};

export default useDeleteBasketItem;
